<div class="emds">
  <mat-form-field appearance="outline" class="emds-find-control" (click)="findControlClicked($event)">
    <mat-chip-list #chipList [disabled]="disabled" matPrefix>
      <ng-container>
        <mat-chip class="mat-chip-counter" *ngIf="!singleSelect && auto.isOpen">
          {{'+'+chips.length}}
        </mat-chip>
        <mat-chip *ngFor="let chip of chips"
                  (click)="findControlClicked($event)"
                  [disabled]="disabled"
                  [hidden]="!singleSelect && auto.isOpen"
                  (removed)="removeChip(chip)">
          <div class="chip-name-container">
            {{getChipDisplayName(chip)}}
          </div>
          <button matChipRemove *ngIf="!disabled">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </ng-container>
    </mat-chip-list>
    <input
      [placeholder]="this.chips.length < 1 ? this.placeHolder : ''"
      [readonly]="disabled"
      #chipInput
      [formControl]="autoCompleteFormControl"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="false"
      [matAutocomplete]="auto"
      type="text"
      apChildId="input"
      class="emds-find-control-text-input">
    <mat-autocomplete class="emds"
                      #auto="matAutocomplete">
      <ng-container *ngIf="autocompleteGroups$ | async as autocompleteGroups">
        <mat-option *ngIf="autocompleteGroups | toCurrentlyLoading" class="loading-option" [disabled]="true">
          <ap-spinner size="2"></ap-spinner>
        </mat-option>
        <mat-optgroup class="find-control-dropdown-group"
                      [hidden]="autocompleteGroups | toCurrentlyLoading"
                      *ngFor="let group of (autocompleteGroups | toLoadedValue)?.value"
                      [label]="group.Name">
          <mat-option *ngFor="let option of group.ItemList"
                      [value]="option"
                      class="default-cursor">
            <div class="flex-row center-v">
              {{getAutocompleteDisplayName(option)}}
              <mat-icon class="clickable flex-pull-right"
                        (click)="removeChip(option)">cancel
              </mat-icon>
            </div>
          </mat-option>
          <mat-option *ngIf="!group.ItemList.length && !group.isCollapsed" [disabled]="true" translate>
            No items available
          </mat-option>
        </mat-optgroup>
      </ng-container>
    </mat-autocomplete>
    <mat-icon
      matSuffix
      class="emds-find-control-icon clickable"
      (click)="openModal()"
      #openModalButton
    >search</mat-icon>
  </mat-form-field>
</div>
